import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Landmark, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

/** Gestione: riepilogo verifica bandi per Comune con link alla sezione dedicata. */
export const VerificaBandiBox = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/bandi-verifica", { params: { stato: "pubblicato" } }).then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  const c = d.conteggi;
  return (
    <Link to="/gestione/bandi-verifica" className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-white p-4 hover:border-[#0070BA] transition-colors" data-testid="verifica-bandi-box">
      <Landmark size={18} className="text-[#003087]" />
      <div className="flex-1 min-w-0"><div className="font-medium text-slate-900">Verifica bandi balneari per Comune</div><div className="text-xs text-slate-500">{d.totale} Comuni costieri · {c.atteso} monitorati · <b className="text-amber-700">{c.pubblicato} da verificare</b> · {c.definitivo} bandi definitivi confermati</div></div>
      {c.pubblicato > 0 && <span className="rounded-full bg-amber-50 text-amber-800 px-2.5 py-0.5 text-xs font-semibold" data-testid="verifica-bandi-da-verificare">{c.pubblicato} da verificare</span>}
      <ArrowRight size={16} className="text-slate-400" />
    </Link>
  );
};
